import React, { useEffect, useState } from "react";
import { Redirect, RouteComponentProps, useLocation } from "react-router-dom";
import { getAuthToken } from "../lib/cookie-manager";

type PrivateRouteProps = {
  component: React.ComponentType<RouteComponentProps>;
  path: string;
  exact?: boolean;
};

export function PrivateRoute(props: PrivateRouteProps): React.ReactElement {
  const location = useLocation();
  const token = getAuthToken();

  if (!token) {
    return (
      <Redirect
        to={{
          pathname: "/auth",
          search: "?next=" + encodeURIComponent(location.pathname + location.search),
        }}
      />
    );
  }

  return <props.component {...({} as RouteComponentProps)} />;
}

export function AuthGuard(props: { children: React.ReactNode }): React.ReactElement | null {
  const location = useLocation();
  const [checked, setChecked] = useState(false);
  const [allowed, setAllowed] = useState(false);

  useEffect(function () {
    const token = getAuthToken();
    setAllowed(!!token);
    setChecked(true);
  }, []);

  if (!checked) {
    return null;
  }

  if (!allowed) {
    return (
      <Redirect
        to={{
          pathname: "/auth",
          search: "?next=" + encodeURIComponent(location.pathname + location.search),
        }}
      />
    );
  }

  return <>{props.children}</>;
}
